import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import creatorReducer from "./slices/creator";
import { wishlistApi, discoverApi } from "./apiSlices";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const creatorPersistConfig = {
  key: "creator",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  creator: persistReducer(creatorPersistConfig, creatorReducer),
  [wishlistApi.reducerPath]: wishlistApi.reducer,
  [discoverApi.reducerPath]: discoverApi.reducer,
});

export default rootReducer;
